import { getService, postService } from '../api/service.js'

// 分销商登录
export const signPost = params => {
  return postService('/api/distributor/distributorLogin', params)
}
// 分销商验证码
export const codeGet = params => {
  return getService('/api/auth/getCaptcha', params)
}

// 分销商token刷新

export const tokenFreshPost = params => {
  return postService('/api/distributor/distributorRefresh', params)
}
// 分销商退出登录

export const distributorLogout = params =>{ 
  return postService('/api/distributor/distributorLogout', params)
}


// 景区登录

export const Login = params =>{ 
  return postService('/api/auth/Login', params)
}
// 景区修改密码

export const updatePassword = params =>{ 
  return postService('/api/auth/updatePassword', params)
}
